// extracted by mini-css-extract-plugin
module.exports = {"effect":"FeatureDetails_effect__KLWTx","features":"FeatureDetails_features__21ZIz","moreFeatures":"FeatureDetails_moreFeatures__RO_uY","case":"FeatureDetails_case__bPj0Q"};